import qs from 'qs'
import axios from '../index'
/**
 * @description 获取商品分类
 * @author cc
 * @date 2020-03-25
 * @export
 */
export function productCategory () {
  return axios.get('/product/category')
}
/**
 * @description 商品列表
 * @author cc
 * @date 2020-03-25
 * @export
 */
export function productCategoryList (params) {
  return axios.get('/product/loadcategorylist', { params })
}
// export function productCategoryList (params) {
//   return axios.get('/product/loadcategorylist', { params,
//     headers: {
//       loading: true
//     } })
// }
/**
 * @description 快捷采购筛选数据
 * @author cc
 * @date 2020-05-18
 * @export
 */
export function categorylist (params) {
  return axios.get('/product/categorylist', { params }
  )
}
/**
 * @description 快捷采购获取促销套餐详情
 * @author cc
 * @date 2020-05-18
 * @export
 */
export function loadPromotionDetail (params) {
  return axios.post('/product/load-promotion-detail', qs.stringify(params))
}
/**
 * @description 搜索页搜索框热词
 * @author cc
 * @date 2020-06-02
 * @export
 */
export function productSearch () {
  return axios.post('/product/search')
}
/**
 * @description 搜索页实时搜索结果
 * @author cc
 * @date 2020-06-03
 * @export
 */
export function jonSearch (params) {
  return axios.get('/json/search', { params })
}
